import { Grid } from '@mui/material';
import React from 'react';
import styles from './styles.module.css';
import { SlideParagraph } from '../slide-paragraph';
import { SlideSubtitle } from '../slide-subtitle/slide-subtitle';

export const Disclosures = React.memo((): React.ReactElement => {
  return (
    <Grid container direction="column">
      <Grid item className={styles.container}>
        <SlideParagraph style={{ fontSize: '11px' }}>
          Bloomberg® and the referenced Bloomberg Index are service marks of
          Bloomberg Finance L.P. and its affiliates, (collectively, “Bloomberg”)
          and are used under license. Bloomberg does not approve or endorse this
          material, nor guarantees the accuracy or completeness of any
          information herein. Bloomberg and AssetMark, Inc. are separate and
          unaffiliated companies.
        </SlideParagraph>
        <SlideParagraph style={{ fontSize: '11px', fontWeight: 300 }}>
          Source: MSCI. MSCI information may only be used for your internal use,
          may not be reproduced or redisseminated in any form and may not be
          used as a basis for or a component of any financial instruments or
          products or indices. None of the MSCI information is intended to
          constitute investment advice or recommendation to make (or refrain
          from making) any kind of investment decision and may not be relied on
          as such. Historical data and analysis should not be taken as an
          indication or guarantee of any future performance. MSCI information is
          provided on an &quot;as is&quot; basis and the user of this
          information assumes the entire risk of any use made of this
          information.
          <br />
          MSCI, each of its affiliates and each other person involved in or
          related to compiling, computing or creating any MSCI information
          (collectively, the &quot;MSCI Parties&quot;) expressly disclaims all
          warranties with respect to this information. In no event shall any of
          the MSCI Parties have any liability for any direct, indirect, special,
          incidental, punitive, consequential (including, without limitation,
          lost profits) or any other damages. (www.msci.com).
        </SlideParagraph>

        <SlideParagraph style={{ fontSize: '11px' }}>
          Please read the Terms of Use posted at www.ewealthmanager.com that
          govern the use of these materials and also be advised:
        </SlideParagraph>
        <SlideParagraph style={{ fontSize: '11px' }}>
          AssetMark uses financial market information (“Information”) from
          third-party providers (“Providers”) in reports (“Materials”). The
          Information includes, but is not limited to, financial market data,
          quotes, news, analyst opinions and research reports. The Materials are
          for informational purposes only, not a solicitation or for use in the
          creation/management/offering/sale of any financial instrument or
          product based thereon and should not be considered investment, legal
          or tax advice. The Information has been drawn from sources believed to
          be reliable, but its accuracy and timeliness is not guaranteed, and is
          subject to change. You agree that neither AssetMark nor the Providers
          are liable for the use of the Information.
        </SlideParagraph>
        <SlideParagraph style={{ fontSize: '11px' }}>
          You agree not to redistribute the Information to recipients not
          authorized by AssetMark. You agree that the Providers are considered
          to be third-party beneficiaries of the Terms of Use.
        </SlideParagraph>
      </Grid>
      <Grid
        container
        justifyContent="space-between"
        alignItems="flex-end"
        bgcolor="#f5f5f5"
        className={styles.subContainer}
      >
        <Grid item xs={12} md={2} lg={2} sm={2} marginBottom={10}>
          <SlideParagraph style={{ fontSize: '10px' }}>
            <b style={{ display: 'block' }}>AssetMark, Inc.</b>
            <span style={{ display: 'block' }}>1655 Grant Street</span>
            <span style={{ display: 'block' }}>10th Floor</span>
            <span style={{ display: 'block' }}>Concord, CA</span>
            <span style={{ display: 'block' }}>94520-2445</span>
            <span style={{ display: 'block' }}>800-664-5345</span>
          </SlideParagraph>
        </Grid>
        <Grid item xs={12} md={10} lg={10} sm={10}>
          <SlideSubtitle style={{ fontSize: '16px', paddingBottom: '1px' }}>
            Important Information
          </SlideSubtitle>
          <SlideParagraph style={{ fontSize: '11px' }}>
            The consideration of AssetMark proprietary strategies, including
            investment strategies managed by AssetMark, during the investment
            consulting process creates a conflict of interest for AssetMark as
            AssetMark receives fees for the management of those strategies and
            funds.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            The recipient of this report, and not AssetMark, is responsible for
            the individualized suitability analyses and determinations as well
            as the investment recommendations for his or her clients. Materials
            provided by AssetMark in connection with this engagement, including
            any sample portfolios, are based on general information provided by
            the recipient of this report about his or her practice and are not
            individualized or client-specific investment advice. In providing
            investment consulting services AssetMark is not exercising
            investment discretion over any client account. Past investment
            performance is not a guarantee of future results and there is no
            guarantee that materials provided by AssetMark hereunder, including
            any sample portfolios, will produce any particular investment
            outcome.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            This report is for informational purposes only, is not a
            solicitation, and should not be considered investment, legal, or tax
            advice. The information has been drawn from sources believed to be
            reliable, but its accuracy is not guaranteed, and is subject to
            change. Financial advisors may seek more information by contacting
            AssetMark at 800-664-5345.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            <b>
              Investing involves risk, including the possible loss of principal.
              Past performance does not guarantee future results.
            </b>
            {` `} Asset allocation cannot eliminate the risk of fluctuating
            prices and uncertain returns. There is no guarantee that a
            diversified portfolio will outperform a non-diversified portfolio.
            No investment strategy, such as asset allocation, can guarantee a
            profit or protect against loss. Actual client results will vary
            based on investment selection, timing, market conditions, and tax
            situation. It is not possible to invest directly in an index.
            Indexes are unmanaged, do not incur management fees, costs, and
            expenses, and cannot be invested in directly. Index performance
            assumes the reinvestment of dividends. Investments in equities,
            bonds, options, and other securities, whether held individually or
            through mutual funds and exchange-traded funds, can decline
            significantly in response to adverse market conditions,
            company-specific events, changes in exchange rates, and domestic,
            international, economic, and political developments. Investments in
            bonds and fixed income-related securities involve market and
            interest rate risk (prices can decline, if interest rates increase),
            and default risk (an issuer being unable to repay principal and
            interest). High-yield bonds are generally subject to a greater risk
            of default than investment-grade bonds. Real estate investments are
            subject to credit and market risks, typically based on changes in
            interest rates and varied economic conditions. Investing in
            alternative investments, including managed futures, commodities, and
            currencies is not appropriate for all persons, as the risk of loss
            is substantial. Investments in futures involve market, counterparty,
            leverage, liquidity, interest rate, foreign currency, commodity,
            volatility, and other risks.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            The exclusion of investments based on industry or ESG factors
            reduces the number of available investment choices and can impact
            overall investment performance.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            <b>
              For more complete information about the various investment
              solutions available, including the investment objectives, risks,
              and fees, please refer to the Disclosure Brochure and applicable
              Fund Prospectus. Please read them carefully before investing. For
              a copy, please contact AssetMark.
            </b>
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            CFA® and Chartered Financial Analyst® are registered trademarks of
            CFA Institute.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            AssetMark, Inc. is an investment adviser registered with the U.S.
            Securities and Exchange Commission.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            AssetMark Asset Management, a division of AssetMark, Inc., includes
            the firm’s proprietary investment strategies. GuideMark® and
            GuidePath®. Funds are distributed by AssetMark Brokerage , LLC,
            member FINRA, an affiliate of AssetMark, Inc. AssetMark and
            third-party strategists and service providers are separate and
            unaffiliated companies. Each party is responsible for its own
            content and services.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            © {new Date().getFullYear()} AssetMark, Inc. All rights reserved.
          </SlideParagraph>
          <SlideParagraph style={{ fontSize: '11px' }}>
            104380 | XXXXXXX.X 02/2025 | EXP 03/31/2028
          </SlideParagraph>
        </Grid>
      </Grid>
    </Grid>
  );
});
